// @ts-check
// O que a linha "Comunicações de marketing" mostra (2.0.0, contrato 09 de campanhas base, seção 6.9): a situação da
// pessoa (marcada, pode receber ou bloqueada por outro motivo), a base ou o motivo, o canal que destoa e quais botões
// aparecem. Regra pura, testada sem montar a ficha.

/** Canais que a linha resume; o SMS não tem envio de marketing na 2.0.0. */
export const MARKETING_ROW_CHANNELS = Object.freeze(['EMAIL', 'WHATSAPP']);

/**
 * @typedef {import('../data/marketing-consent.js').MarketingStatus} MarketingStatus
 * @typedef {{
 *   state: 'optedOut' | 'eligible' | 'blocked', basis: string | null, reason: string | null,
 *   otherChannels: Array<{ channel: string, isEligible: boolean, basis: string | null, reason: string | null }>,
 *   optOutAt: string | null, optOutSource: string | null, pendingRequestAt: string | null,
 *   canMark: boolean, canRegister: boolean,
 * }} MarketingRowDisplay
 */

/**
 * @param {MarketingStatus} status
 * @returns {MarketingRowDisplay}
 */
export function describeMarketingStatus(status) {
  const channels = MARKETING_ROW_CHANNELS.map((channel) => ({ channel, ...(status.channels?.[channel] ?? { isEligible: false, basis: null, reason: null }) }));
  const eligible = channels.find((channel) => channel.isEligible) ?? null;
  const main = eligible ?? channels[0];
  const state = status.isOptedOut ? 'optedOut' : eligible ? 'eligible' : 'blocked';
  // o canal com situação diferente da principal ganha uma nota curta (por exemplo, WhatsApp sem a base do funil)
  const otherChannels = state === 'optedOut' ? [] : channels.filter((channel) => channel.channel !== main.channel
    && (channel.isEligible !== main.isEligible || channel.reason !== main.reason));
  return {
    state,
    basis: state === 'eligible' ? main.basis : null,
    reason: state === 'blocked' ? main.reason : null,
    otherChannels,
    optOutAt: status.optOut?.at ?? null,
    optOutSource: status.optOut?.source ?? null,
    pendingRequestAt: status.isOptedOut ? status.pendingConsentRequest?.at ?? null : null,
    canMark: Boolean(status.canMarkOptOut) && !status.isOptedOut && !status.isAnonymized,
    // marcada: só com SECURITY (o servidor diz); bloqueada por falta de consentimento: quem edita a pessoa registra
    canRegister: Boolean(status.canRegisterConsent) && !status.isAnonymized && state !== 'eligible',
  };
}

/**
 * Pessoa da linha: a própria pessoa, ou o contato principal do card. Outro objeto ou card sem contato: nenhuma.
 * @param {string} objectNameSingular @param {Record<string, any> | null | undefined} record
 * @returns {{ personId: string, variant: 'person' | 'contact' } | null}
 */
export function marketingRowTarget(objectNameSingular, record) {
  if (!record?.id) return null;
  if (objectNameSingular === 'person') return { personId: String(record.id), variant: 'person' };
  if (objectNameSingular === 'enrollmentOpportunity' && record.pointOfContactId) return { personId: String(record.pointOfContactId), variant: 'contact' };
  return null;
}
